import { Route } from "react-router-dom";
import { ProtectedRoute } from "../../routers/protected-route";
import { Favorites } from "./pages";

export const FavoritesRouter = [
  <Route
    path="/favorites"
    element={
      <ProtectedRoute roles={["Any"]}>
        <Favorites />
      </ProtectedRoute>
    }
  />,
];
